import {BaseDataSource} from './BaseDataSource';
import {Product} from '../Entities/Product';
import {Document} from '../Entities/Document';

/**
 * Data source to provide what data should be rendered in the table. The observable provided
 * in connect should emit exactly the data that should be rendered by the table. If the data is
 * altered, the observable should emit that new set of data on the stream. In our case here,
 * we return a stream that contains only one set of data that doesn't change.
 */
export class DocumentsDataSource extends BaseDataSource<Document> {
}



// WEBPACK FOOTER //
// /app/src/model/DataSources/DocumentsDataSource.ts